import { createClient } from '@supabase/supabase-js';

export const sb = createClient(
  'https://ybesiwsrfgjqulfaoaui.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InliZXNpd3NyZmdqcXVsZmFvYXVpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA0MTY4NDMsImV4cCI6MjA5NTk5Mjg0M30.kMtRaQpqH6o8dY6Je0tO-iF09IKLocJ6eJh_nUVcUbo'
);
